import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const NotFound = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        backgroundColor: '#f5f5f5',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: '500px',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '40px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            fontSize: '48px',
            marginBottom: '20px',
          }}
        >
          🔍
        </div>

        <h1
          style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#262626',
            marginBottom: '12px',
          }}
        >
          {t('route.notFound.title')}
        </h1>

        <p
          style={{
            fontSize: '14px',
            color: '#8c8c8c',
            marginBottom: '24px',
            lineHeight: '1.5',
          }}
        >
          {t('route.notFound.message')}
        </p>

        <div
          style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center',
          }}
        >
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '8px 24px',
              fontSize: '14px',
              fontWeight: '500',
              color: 'white',
              backgroundColor: '#1890ff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.3s',
            }}
            onMouseOver={e => (e.currentTarget.style.backgroundColor = '#40a9ff')}
            onMouseOut={e => (e.currentTarget.style.backgroundColor = '#1890ff')}
          >
            {t('route.goHome')}
          </button>

          <button
            onClick={() => navigate(-1)}
            style={{
              padding: '8px 24px',
              fontSize: '14px',
              fontWeight: '500',
              color: '#595959',
              backgroundColor: 'white',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.3s',
            }}
            onMouseOver={e => {
              e.currentTarget.style.borderColor = '#40a9ff'
              e.currentTarget.style.color = '#40a9ff'
            }}
            onMouseOut={e => {
              e.currentTarget.style.borderColor = '#d9d9d9'
              e.currentTarget.style.color = '#595959'
            }}
          >
            {t('route.goBack')}
          </button>
        </div>
      </div>
    </div>
  )
}
